import { ReactNode } from "react";

type ButtonType = {
  children: ReactNode;
  className?: string;
};

export const HeroButton = ({ className, children }: ButtonType) => {
  return (
    <div
      className={`text-sm mx-auto sm:text-base font-bold flex w-full lg:max-w-fit  h-[50px] ${className}`}
    >
      <button className="outline-none border-none bg-hero-pink-200 dark:text-white rounded-full w-full px-6 text-white flex  shadow-xl hover:opacity-90">
        <span className="m-auto object-fill">{children}</span>
      </button>
    </div>
  );
};

export default HeroButton;
